// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1StatePermissionSchema } from './v1/statePermissionSchema';
import { v1StatePermissionsCreateSchema } from './v1/statePermissions/createSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const createStatePermissionsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  state_id: z.number().int().describe("State ID"),
});

export const createStatePermissionsHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description State permissions created successfully
 */
export const createStatePermissions201Schema = z.array(z.lazy(() => v1StatePermissionSchema));

/**
 * @description Unauthorized
 */
export const createStatePermissions401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const createStatePermissionsMutationRequestSchema = z.lazy(() => v1StatePermissionsCreateSchema);

export const createStatePermissionsMutationResponseSchema = z.lazy(() => createStatePermissions201Schema);
